__turbopack_context__.v({
  "dropdown": "bets-history-tools-module-sass-module__0cnwWG__dropdown",
  "tools": "bets-history-tools-module-sass-module__0cnwWG__tools",
});
